module.exports = __webpack_public_path__ + "static/media/casestudy-dark.e6a82aa1.png";